import { FeedbackInsights } from "@coaching-culture/types";
import { EmptyState, Loader, Panel } from "@coaching-culture/ui";
import { FaBan, FaHourglassHalf } from "react-icons/fa";

export const CampaignInsightsWrap = ({
  insights,
  render,
}: {
  insights: null | false | "not-available-yet" | FeedbackInsights;
  render: () => JSX.Element;
}) => {
  return insights === false ? (
    <Panel>
      <EmptyState icon={FaBan}>
        Results for this campaign are not visible to you.
      </EmptyState>
    </Panel>
  ) : insights === "not-available-yet" ? (
    <Panel>
      <EmptyState icon={FaHourglassHalf}>
        Results on an anonymous survey are not available until at least 5
        respondents have completed it.
      </EmptyState>
    </Panel>
  ) : insights == null ? (
    <Loader />
  ) : (
    render()
  );
};
